import { bodySmallStyles } from '@lifebit-ai/lds'
import styled from 'styled-components'

export const RejectionMessage = styled.div`
  ${bodySmallStyles};
  color: ${({ theme }) => theme.color.feedback.danger.default};
  max-width: 560px;
`
